import {pluginRegistry} from "../core/plugin/PluginRegistry";
import {
    MyLeaveRequestsDashboardPluginConfiguration,
    PendingLeaveRequestsDashboardPluginConfiguration
} from "./dashboard/pending-requests/leave-requests";
import PendingApprovalsDashboardPlugin from "./dashboard/pending-approvals";
import CurrentWorkTimeDashboardPlugin from "./dashboard/clockinout";
import TimeRecordHistoryDashboardPlugin from "./dashboard/timerecordhistory";
import PendingRequestsDashboardPlugin
    from "./dashboard/pending-requests/pending-requests/PendingRequestsDashboardPlugin";
import {PendingRequestsDashboardPluginConfiguration} from "./dashboard/pending-requests/pending-requests";

/**
 * Register built-in plugins with the plugin registry
 */
export function registerBuiltInPlugins() {

    // Dashboard plugins
    // pluginRegistry.registerPlugin(EmployeesBirthdaysDashboardPlugin);
    // pluginRegistry.registerPlugin(PendingEmployeeRequestsDashboardPluginConfiguration);

    // pluginRegistry.registerPlugin(PendingLeaveRequestsDashboardPluginConfiguration)
    pluginRegistry.registerPlugin(MyLeaveRequestsDashboardPluginConfiguration);
    pluginRegistry.registerPlugin(PendingApprovalsDashboardPlugin);
    // pluginRegistry.registerPlugin(PendingRequestsDashboardPluginConfiguration);
    pluginRegistry.registerPlugin(CurrentWorkTimeDashboardPlugin);
    pluginRegistry.registerPlugin(TimeRecordHistoryDashboardPlugin);

    // Reporting plugins
    // pluginRegistry.registerPlugin(FTETodayReportingPlugin);
    // pluginRegistry.registerPlugin(FTEDevelopmentReportingPlugin);
    // pluginRegistry.registerPlugin(HeadcountDevelopmentReportingPlugin);
}